import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Nav() {
  const [products, setProducts] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const [activeProductId, setActiveProductId] = useState(null);
  const [headerMenus, setHeaderMenus] = useState([]);
  const [headerMenuLoading, setHeaderMenuLoading] = useState(true);

  /*
  |--------------------------------------------------------------------------
  | API
  |--------------------------------------------------------------------------
  */
  const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/+$/,
    "",
  );

  /*
  |--------------------------------------------------------------------------
  | Dil
  |--------------------------------------------------------------------------
  | BannerOne'daki mantığın aynısı.
  */
  const searchParams = new URLSearchParams(window.location.search);

  const currentLang = searchParams.get("lang") || "tr";

  /*
  |--------------------------------------------------------------------------
  | Link oluştururken mevcut dili koru
  |--------------------------------------------------------------------------
  |
  | Örn:
  | /our-service?lang=en
  | /our-service/galvaniz-kapli-tel-24?lang=en
  |
  */
  const withLang = (path = "") => {
    if (!path || path === "#") {
      return path || "#";
    }

    if (!currentLang || currentLang === "tr") {
      return path;
    }

    const separator = path.includes("?") ? "&" : "?";

    return `${path}${separator}lang=${encodeURIComponent(currentLang)}`;
  };
  /*
  |--------------------------------------------------------------------------
  | Türkçe slug oluştur
  |--------------------------------------------------------------------------
  |
  | Galvaniz Kaplı Tel
  | ->
  | galvaniz-kapli-tel
  |
  */
  const createSlug = (text = "") => {
    return String(text)
      .trim()
      .toLocaleLowerCase("tr-TR")
      .replace(/ç/g, "c")
      .replace(/ğ/g, "g")
      .replace(/ı/g, "i")
      .replace(/ö/g, "o")
      .replace(/ş/g, "s")
      .replace(/ü/g, "u")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  /*
  |--------------------------------------------------------------------------
  | HEADER ÜRÜN MENÜSÜNÜ BACKEND'DEN ÇEK
  |--------------------------------------------------------------------------
  */
  useEffect(() => {
    const controller = new AbortController();

    const fetchProductMenu = async () => {
      try {
        setMenuLoading(true);

        const response = await fetch(
          `${API_BASE_URL}/api/blogs/products/menu?lang=${encodeURIComponent(
            currentLang,
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error(`Ürün menüsü alınamadı: ${response.status}`);
        }

        const data = await response.json();

        console.log("PRODUCT_MENU_API:", data);

        /*
         * Backend direkt array döndürürse:
         * [...]
         *
         * veya:
         *
         * {
         *   success: true,
         *   data: [...]
         * }
         *
         * ikisini de kabul ediyoruz.
         */
        if (Array.isArray(data)) {
          setProducts(data);
        } else if (Array.isArray(data?.data)) {
          setProducts(data.data);
        } else {
          setProducts([]);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("PRODUCT_MENU_API_ERROR:", error);

          setProducts([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setMenuLoading(false);
        }
      }
    };

    fetchProductMenu();

    return () => {
      controller.abort();
    };
  }, [API_BASE_URL, currentLang]);

  /*
|--------------------------------------------------------------------------
| DİNAMİK HEADER MENÜLERİNİ ÇEK
|--------------------------------------------------------------------------
|
| Ürünler ve Uygulamalar buradan gelmez.
| O mevcut yapısıyla her zaman ilk sırada kalır.
|
| Buradan:
| - Kurumsal
|   - Hakkımızda
|   - Biz Kimiz?
|   - Neden Biz?
|   - ...
| - Kalite
| - İnsan Kaynakları
| - İletişim
|
| gelir.
*/
  useEffect(() => {
    const controller = new AbortController();

    const fetchHeaderMenus = async () => {
      try {
        setHeaderMenuLoading(true);

        const response = await fetch(
          `${API_BASE_URL}/api/frontend-menu/category-menu?lang=${encodeURIComponent(
            currentLang,
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error(`Header menüsü alınamadı: ${response.status}`);
        }

        const responseData = await response.json();

        console.log("HEADER_MENU_API:", responseData);

        let menuData = [];

        if (Array.isArray(responseData)) {
          menuData = responseData;
        } else if (Array.isArray(responseData?.data)) {
          menuData = responseData.data;
        }

        const normalizedMenus = menuData
          .filter((menu) => {
            return menu.is_visible === true || Number(menu.is_visible) === 1;
          })
          .map((menu) => {
            const children = Array.isArray(menu.children)
              ? menu.children
                  .filter((child) => {
                    return (
                      child.is_visible === true ||
                      Number(child.is_visible) === 1
                    );
                  })
                  .sort(
                    (a, b) =>
                      Number(a.sort_order ?? 0) - Number(b.sort_order ?? 0),
                  )
              : [];

            return {
              ...menu,
              children,
            };
          })
          .sort(
            (a, b) => Number(a.sort_order ?? 0) - Number(b.sort_order ?? 0),
          );

        console.log("HEADER_MENUS_NORMALIZED:", normalizedMenus);

        setHeaderMenus(normalizedMenus);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("HEADER_MENU_API_ERROR:", error);

          setHeaderMenus([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setHeaderMenuLoading(false);
        }
      }
    };

    fetchHeaderMenus();

    return () => {
      controller.abort();
    };
  }, [API_BASE_URL, currentLang]);

  const normalProducts = products.flatMap((category) =>
    Array.isArray(category.products) ? category.products : [],
  );

  const allProducts = products.flatMap((category) => {
    if (!Array.isArray(category.products)) {
      return [];
    }

    return category.products;
  });

  return (
    <>
      <style>
        {`
          .products-menu-item {
            position: relative !important;
          }

          /*
           * Ana açılır menü alanı
           */
        .products-mega-dropdown {
  position: absolute;
  top: calc(100% + 14px);
  left: 0;

  width: 290px;   /* 680px DEĞİL */

  margin: 0;
  padding: 0;

  background: transparent;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  transform: translateY(10px);

  transition:
    opacity 0.2s ease,
    visibility 0.2s ease,
    transform 0.2s ease;

  z-index: 9999;
}

          /*
           * Ana bağlantı ile açılır menü arasında
           * boşluk oluşursa mouse geçerken
           * menünün kapanmasını engeller.
           */
          .products-mega-dropdown::before {
            content: "";
            position: absolute;
            top: -18px;
            left: 0;

            width: 100%;
            height: 18px;
          }

          /*
           * Ürünler ve Uygulamalar üzerine gelince
           * menüyü aç
           */
       .products-menu-item:hover
  > .products-mega-dropdown {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
}

          /*
           * SOL KATEGORİ MENÜSÜ
           */
          .products-left-column {
            position: relative;

            width: 290px;
            margin: 0;
            padding: 10px 0;

            background: #171717;

            border: none;
            border-radius: 0;

            box-shadow:
              0 14px 35px
              rgba(0, 0, 0, 0.3);

            max-height: 510px;

            overflow-y: auto;
            overflow-x: hidden;

            z-index: 2;
          }

          .products-list {
            display: block !important;

            width: 100%;

            margin: 0 !important;
            padding: 0 !important;

            list-style: none !important;
          }

          .products-list > li {
            display: block !important;

            width: 100%;
            height: 50px;

            margin: 0 !important;
            padding: 0 !important;

            list-style: none !important;
          }

          .product-menu-button {
            display: flex !important;

            align-items: center;
            justify-content: space-between;

            gap: 14px;

            width: 100%;
            height: 50px;

            margin: 0 !important;
            padding: 0 20px !important;

            color: #ffffff !important;
            background: transparent;

            border: none;
            border-bottom:
              1px solid
              rgba(255, 255, 255, 0.06);

            font-family: inherit;
            font-size: 15px !important;
            font-weight: 600 !important;
            line-height: 1.4 !important;

            text-align: left;
            text-decoration: none !important;

            cursor: pointer;

            transition:
              background-color 0.2s ease,
              padding-left 0.2s ease;
          }

          .products-list
            > li:last-child
            .product-menu-button {
            border-bottom: none;
          }

          /*
           * Seçilen veya üzerine gelinen kategori
           */
          .product-menu-button:hover,
          .product-menu-button.active {
            padding-left: 25px !important;

            color: #ffffff !important;
            background: #1b4793;
          }

          .product-menu-arrow {
            flex-shrink: 0;

            font-size: 22px;
            font-weight: 400;
            line-height: 1;
          }

          /*
           * SAĞ ÜRÜNLER / UYGULAMALAR MENÜSÜ
           */
          .applications-right-column {
            position: absolute;

            left: 290px;

            width: 390px;

            margin: 0;
            padding: 10px 0;

            background: #1d1d1d;

            border: none;
            border-left:
              1px solid
              rgba(255, 255, 255, 0.09);

            border-radius: 0;

            box-shadow:
              8px 14px 35px
              rgba(0, 0, 0, 0.26);

            max-height: 410px;

            overflow-y: auto;
            overflow-x: hidden;

            z-index: 1;

            animation:
              applicationsMenuOpen
              0.18s ease;
          }

          @keyframes applicationsMenuOpen {
            from {
              opacity: 0;
              transform: translateX(-5px);
            }

            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          .applications-list {
            display: block !important;

            width: 100%;

            margin: 0 !important;
            padding: 0 !important;

            list-style: none !important;
          }

          .applications-list > li {
            display: block !important;

            width: 100%;

            margin: 0 !important;
            padding: 0 !important;

            list-style: none !important;
          }

          .application-menu-link {
            display: flex !important;

            align-items: center;

            width: 100%;
            min-height: 48px;

            margin: 0 !important;
            padding: 11px 26px !important;

            color: #ffffff !important;
            background: transparent;

            font-size: 15px !important;
            font-weight: 500 !important;
            line-height: 1.45 !important;

            text-align: left;
            text-decoration: none !important;

            border-bottom:
              1px solid
              rgba(255, 255, 255, 0.06);

            transition:
              background-color 0.2s ease,
              padding-left 0.2s ease;
          }

          .applications-list
            > li:last-child
            .application-menu-link {
            border-bottom: none;
          }

          .application-menu-link:hover {
            padding-left: 32px !important;

            color: #ffffff !important;
            background: #1b4793;
          }

          /*
           * Temanın alt menü bağlantılarına
           * eklediği çizgi ve işaretleri kaldır.
           */
          .products-mega-dropdown a::before,
          .products-mega-dropdown a::after {
            display: none !important;
            content: none !important;
          }

          /*
           * Ana menü bağlantısı ve aşağı oku
           */
          .products-main-link {
            display: flex !important;

            align-items: center;

            gap: 8px;
          }

          .products-down-arrow {
            display: inline-block;

            width: 8px;
            height: 8px;

            margin-top: -4px;

            border-right:
              2px solid currentColor;

            border-bottom:
              2px solid currentColor;

            transform: rotate(45deg);

            transition:
              transform 0.2s ease,
              margin-top 0.2s ease;
          }

          .products-menu-item:hover
            .products-down-arrow {
            margin-top: 4px;

            transform: rotate(225deg);
          }

          /*
           * Sağ menü scrollbar
           */
          .applications-right-column
            ::-webkit-scrollbar {
            width: 8px;
          }

          .applications-right-column
            ::-webkit-scrollbar-track {
            background: #141414;
          }

          .applications-right-column
            ::-webkit-scrollbar-thumb {
            background: #606060;

            border:
              2px solid #141414;

            border-radius: 10px;
          }

          .applications-right-column
            ::-webkit-scrollbar-thumb:hover {
            background: #858585;
          }

          /*
           * Sol menü scrollbar
           */
          .products-left-column
            ::-webkit-scrollbar {
            width: 7px;
          }

          .products-left-column
            ::-webkit-scrollbar-track {
            background: #111111;
          }

          .products-left-column
            ::-webkit-scrollbar-thumb {
            background: #505050;

            border:
              2px solid #111111;

            border-radius: 10px;
          }

          .products-left-column,
          .applications-right-column {
            scrollbar-width: thin;
            scrollbar-color:
              #606060 #141414;
          }

          /*
           * Orta masaüstü
           */
          @media (max-width: 1399px) {
            .products-mega-dropdown {
              left: -35px;
              width: 620px;
            }

            .products-left-column {
              width: 260px;
            }

            .applications-right-column {
              left: 260px;
              width: 360px;
            }

            .product-menu-button,
            .application-menu-link {
              font-size: 14px !important;
            }
          }

          /*
           * Eski "Tümünü Gör" classı
           * ileride gerekirse kullanılabilir.
           */
          .applications-view-all {
            color: #ff3838 !important;
            font-weight: 700 !important;

            text-decoration:
              underline !important;

            text-decoration-color:
              #ff3838 !important;

            text-decoration-thickness:
              2px !important;

            text-underline-offset:
              6px !important;
          }

          .application-menu-link
            .applications-view-all:hover {
            color: #ff6666 !important;

            background:
              transparent !important;

            padding-left:
              26px !important;

            text-decoration-color:
              #ff6666 !important;
          }

          /*
           * SADECE MASAÜSTÜ
           * SATIRLARI DARALT
           */
          @media (min-width: 1200px) {
            /*
             * Sol kategori kutusu
             */
            .products-menu-item
              .products-mega-dropdown
              .products-left-column {
              padding-top:
                6px !important;

              padding-bottom:
                6px !important;

              max-height:
                390px !important;
            }

            /*
             * Sol kategori satırları
             */
            .products-menu-item
              .products-mega-dropdown
              .products-list
              > li {
              height:
                40px !important;

              min-height:
                40px !important;

              max-height:
                40px !important;

              margin:
                0 !important;

              padding:
                0 !important;
            }

            .products-menu-item
              .products-mega-dropdown
              .product-menu-button {
              height:
                40px !important;

              min-height:
                40px !important;

              max-height:
                40px !important;

              padding-top:
                0 !important;

              padding-bottom:
                0 !important;

              box-sizing:
                border-box !important;
            }

            .products-menu-item
              .products-mega-dropdown
              .product-menu-button:hover,
            .products-menu-item
              .products-mega-dropdown
              .product-menu-button.active {
              padding-top:
                0 !important;

              padding-bottom:
                0 !important;
            }

            /*
             * Sağ ürün kutusu
             */
            .products-menu-item
              .products-mega-dropdown
              .applications-right-column {
              padding-top:
                6px !important;

              padding-bottom:
                6px !important;

              max-height:
                366px !important;
            }

            /*
             * Sağ ürün satırları
             */
            .products-menu-item
              .products-mega-dropdown
              .applications-list
              > li {
              height:
                40px !important;

              min-height:
                40px !important;

              max-height:
                40px !important;

              margin:
                0 !important;

              padding:
                0 !important;
            }

            .products-menu-item
              .products-mega-dropdown
              .application-menu-link {
              height:
                40px !important;

              min-height:
                40px !important;

              max-height:
                40px !important;

              padding-top:
                0 !important;

              padding-bottom:
                0 !important;

              box-sizing:
                border-box !important;
            }

            .products-menu-item
              .products-mega-dropdown
              .application-menu-link:hover {
              padding-top:
                0 !important;

              padding-bottom:
                0 !important;
            }

            .products-menu-item
              .products-mega-dropdown
              .application-menu-link
              .applications-view-all,
            .products-menu-item
              .products-mega-dropdown
              .application-menu-link
              .applications-view-all:hover {
              height:
                40px !important;

              min-height:
                40px !important;

              max-height:
                40px !important;

              padding-top:
                0 !important;

              padding-bottom:
                0 !important;
            }
          }

          /*
           * Yükleniyor satırı
           */
          .products-menu-loading {
            display: flex;

            align-items: center;

            width: 100%;
            height: 40px;

            padding: 0 20px;

            color:
              rgba(255,255,255,.7);

            font-size: 14px;
          }

          /*
           * Veri yok
           */
          .products-menu-empty {
            display: flex;

            align-items: center;

            width: 100%;
            min-height: 40px;

            padding: 8px 20px;

            color:
              rgba(255,255,255,.7);

            font-size: 14px;
          }
         /*
|--------------------------------------------------------------------------
| DİNAMİK HEADER MENÜLERİ
| Ürün menüsüyle aynı görünüm
|--------------------------------------------------------------------------
*/

.dynamic-header-menu-item {
  position: relative !important;
}

.dynamic-header-main {
  display: flex !important;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.dynamic-header-main.no-link {
  color: inherit;
}

/*
 * Dropdown dış kutusu
 */
.dynamic-header-dropdown {
  position: absolute;

  top: calc(100% + 14px);
  left: 0;

  width: 290px;

  margin: 0;
  padding: 0;

  background: transparent;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  transform: translateY(10px);

  transition:
    opacity 0.2s ease,
    visibility 0.2s ease,
    transform 0.2s ease;

  z-index: 9999;
}

/*
 * Header ile dropdown arasındaki boşlukta
 * mouse kaçmasın.
 */
.dynamic-header-dropdown::before {
  content: "";

  position: absolute;

  top: -18px;
  left: 0;

  width: 100%;
  height: 18px;
}

/*
 * Hover
 */
.dynamic-header-menu-item:hover
  > .dynamic-header-dropdown {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
}

/*
|--------------------------------------------------------------------------
| ÜRÜN MENÜSÜYLE BİREBİR AYNI SOL KUTU
|--------------------------------------------------------------------------
*/

.dynamic-header-dropdown .products-left-column {
  width: 290px !important;

  padding-top: 6px !important;
  padding-bottom: 6px !important;

  max-height: 390px !important;

  background: #171717;

  overflow-y: auto;
  overflow-x: hidden;
}

/*
 * Temanın ul'yi yatay yapmasını kesin olarak engelle.
 */
.dynamic-header-dropdown .products-list {
  display: block !important;

  width: 100% !important;

  margin: 0 !important;
  padding: 0 !important;

  list-style: none !important;
}

.dynamic-header-dropdown
  .products-list
  > li {
  display: block !important;

  width: 100% !important;

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;

  margin: 0 !important;
  padding: 0 !important;

  list-style: none !important;
}

/*
 * Alt menü linkleri ürün kategorileriyle aynı
 */
.dynamic-header-dropdown
  .product-menu-button {
  display: flex !important;

  align-items: center;
  justify-content: flex-start;

  width: 100% !important;

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;

  margin: 0 !important;
  padding: 0 20px !important;

  color: #ffffff !important;
  background: transparent;

  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;

  text-align: left !important;
  text-decoration: none !important;

  box-sizing: border-box;

  border-bottom:
    1px solid
    rgba(255, 255, 255, 0.06);

  transition:
    background-color 0.2s ease,
    padding-left 0.2s ease;
}

.dynamic-header-dropdown
  .products-list
  > li:last-child
  .product-menu-button {
  border-bottom: none;
}

.dynamic-header-dropdown
  .product-menu-button:hover {
  padding-left: 25px !important;

  color: #ffffff !important;
  background: #1b4793;
}

/*
 * Tema kendi ikon/çizgilerini eklemesin
 */
.dynamic-header-dropdown a::before,
.dynamic-header-dropdown a::after {
  display: none !important;
  content: none !important;
}

/*
|--------------------------------------------------------------------------
| ANA HEADER OKU
|--------------------------------------------------------------------------
*/

.dynamic-header-arrow {
  display: inline-block;

  width: 8px;
  height: 8px;

  margin-top: -4px;

  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;

  transform: rotate(45deg);

  transition:
    transform 0.2s ease,
    margin-top 0.2s ease;
}

.dynamic-header-menu-item:hover
  .dynamic-header-arrow {
  margin-top: 4px;

  transform: rotate(225deg);
}

@media (max-width: 1399px) {
  .dynamic-header-dropdown {
    width: 260px;
  }

  .dynamic-header-dropdown
    .products-left-column {
    width: 260px !important;
  }
}
  /*
|--------------------------------------------------------------------------
| DESKTOP MENÜ HİYERARŞİSİ
|--------------------------------------------------------------------------
*/

/*
|--------------------------------------------------------------------------
| 1. SEVİYE
|
| Ürünler ve Uygulamalar
| Kurumsal
| Kalite
| İnsan Kaynakları
| İletişim
|--------------------------------------------------------------------------
*/

.mainmenu > li > .nav-item,
.mainmenu > li > .products-main-link,
.mainmenu > li > .dynamic-header-main {
  font-family: inherit !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
}


/*
|--------------------------------------------------------------------------
| 2. SEVİYE
|
| Ürün kategorileri:
| Galvaniz Kaplı Tel
| örnek kategori
|
| Frontend menu çocukları:
| Hakkımızda
| Biz Kimiz?
| Neden Biz?
|--------------------------------------------------------------------------
*/

.products-menu-item
  .products-mega-dropdown
  .product-menu-button,

.dynamic-header-menu-item
  .dynamic-header-dropdown
  .product-menu-button {

  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;

  width: 100% !important;

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;

  margin: 0 !important;
  padding: 0 20px !important;

  box-sizing: border-box !important;

  color: #ffffff !important;
  background: transparent;

  border: none !important;
  border-bottom:
    1px solid
    rgba(255, 255, 255, 0.06) !important;

  font-family: inherit !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;

  text-align: left !important;
  text-decoration: none !important;

  cursor: pointer;

  transition:
    background-color 0.2s ease,
    padding-left 0.2s ease;
}


/*
|--------------------------------------------------------------------------
| 2. SEVİYE HOVER / ACTIVE
|--------------------------------------------------------------------------
*/

.products-menu-item
  .products-mega-dropdown
  .product-menu-button:hover,

.products-menu-item
  .products-mega-dropdown
  .product-menu-button.active,

.dynamic-header-menu-item
  .dynamic-header-dropdown
  .product-menu-button:hover {

  padding-left: 25px !important;

  color: #ffffff !important;
  background: #1b4793 !important;
}


/*
|--------------------------------------------------------------------------
| 2. SEVİYE SATIRLAR
|--------------------------------------------------------------------------
*/

.products-menu-item
  .products-mega-dropdown
  .products-list
  > li,

.dynamic-header-menu-item
  .dynamic-header-dropdown
  .products-list
  > li {

  display: block !important;

  width: 100% !important;

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;

  margin: 0 !important;
  padding: 0 !important;

  list-style: none !important;
}


/*
|--------------------------------------------------------------------------
| SON SATIRDA ÇİZGİ YOK
|--------------------------------------------------------------------------
*/

.products-menu-item
  .products-mega-dropdown
  .products-list
  > li:last-child
  .product-menu-button,

.dynamic-header-menu-item
  .dynamic-header-dropdown
  .products-list
  > li:last-child
  .product-menu-button {

  border-bottom: none !important;
}


/*
|--------------------------------------------------------------------------
| 3. SEVİYE
|
| Rulo Boya Teli
| Kova Sapı Teli
| vb.
|--------------------------------------------------------------------------
*/

.products-menu-item
  .applications-right-column
  .application-menu-link {

  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;

  padding: 0 26px !important;

  font-family: inherit !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.4 !important;
}
        `}
      </style>

      <nav className="nav-main mainmenu-nav d-none d-xl-block">
        <ul className="mainmenu">
          <li className="products-menu-item">
            <Link
              className="nav-item products-main-link"
              to={withLang("/our-service")}
            >
              Ürünler
              <span className="products-down-arrow" aria-hidden="true" />
            </Link>

            <div className="products-mega-dropdown">
              <div className="products-left-column">
                <ul className="products-list">
                  {menuLoading && (
                    <li>
                      <div className="products-menu-loading">Yükleniyor...</div>
                    </li>
                  )}

                  {!menuLoading && products.length === 0 && (
                    <li>
                      <div className="products-menu-empty">
                        Kategori bulunamadı.
                      </div>
                    </li>
                  )}

                  {!menuLoading &&
                    products.map((category) => {
                      const categoryTitle =
                        category.title ||
                        category.name ||
                        `Kategori ${category.id}`;

                      const categorySlug = `${createSlug(
                        categoryTitle,
                      )}-${category.id}`;

                      return (
                        <li key={category.id}>
                          <Link
                            className="product-menu-button"
                            to={withLang(`/our-service/${categorySlug}`)}
                          >
                            <span>{categoryTitle}</span>
                          </Link>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </li>

          {/* =====================================================
    DİNAMİK HEADER MENÜLERİ
====================================================== */}

          {!headerMenuLoading &&
            headerMenus.map((menu) => {
              const children = Array.isArray(menu.children)
                ? menu.children
                : [];

              const hasChildren = children.length > 0;

              const menuUrl = menu.url || "#";

              return (
                <li
                  key={`${menu.menuType}-${menu.id}`}
                  className={hasChildren ? "dynamic-header-menu-item" : ""}
                >
                  {/* ============================================
            ANA MENÜ
        ============================================= */}

                  <Link
                    className={`nav-item ${
                      hasChildren ? "dynamic-header-main" : ""
                    }`}
                    to={menuUrl === "#" ? "#" : withLang(menuUrl)}
                    onClick={(e) => {
                      if (menuUrl === "#") {
                        e.preventDefault();
                      }
                    }}
                    data-url-locked={menu.url_locked ?? 0}
                  >
                    {menu.title}

                    {hasChildren && (
                      <span
                        className="dynamic-header-arrow"
                        aria-hidden="true"
                      />
                    )}
                  </Link>

                  {/* ============================================
            ALT MENÜ
        ============================================= */}
                  {hasChildren && (
                    <div className="dynamic-header-dropdown">
                      <div className="products-left-column">
                        <ul className="products-list">
                          {children.map((child) => {
                            const childUrl = child.url || "#";

                            return (
                              <li key={child.id}>
                                {childUrl !== "#" ? (
                                  <Link
                                    className="product-menu-button"
                                    to={withLang(childUrl)}
                                    data-url-locked={child.url_locked ?? 0}
                                  >
                                    <span>{child.title}</span>
                                  </Link>
                                ) : (
                                  <span className="product-menu-button">
                                    <span>{child.title}</span>
                                  </span>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
        </ul>
      </nav>
    </>
  );
}

export default Nav;
